import React from 'react';
import { Link } from 'react-router';

const Footer = () => {

    return (
        <div className="cent-footer">
            <div className="cent-footer-container">
                <ul className="cent-footer-links">
                    <li><Link to="/policy/privacy">Privacy notice</Link></li>
                    <li><Link to="/policy/terms-of-use">Terms of use</Link></li>
                    <li><a href="https://support.premierit.com" target="_blank">Support</a></li>
                </ul>

                <div className="copyright">
                    <a href="https://www.premierit.com" target="_blank">Copyright &copy; 2018 Premier IT</a>
                </div>

            </div>
        </div>
    );
};

export default Footer;
